import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import AuthLayout, { AuthNotice } from './Auth/AuthLayout';
import PasswordField from './Auth/PasswordField';
import { authErrorKey, safeAuthDestination } from '../utils/authFlow';

export default function Login() {
  const { t } = useTranslation('auth');
  const { currentUser, emailVerified } = useAuth();
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || '');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (currentUser) return <Navigate to={emailVerified ? safeAuthDestination(location.state?.from) : "/verify-email"} state={location.state} replace />;
  const submit = async event => {
    event.preventDefault();
    if (busy) return;
    setBusy(true);
    setError('');
    try { await signInWithEmailAndPassword(auth, email.trim(), password); }
    catch (err) { setError(authErrorKey(err)); setBusy(false); }
  };
  return <AuthLayout title={t('login.title')} subtitle={t('login.subtitle')}
    footer={<>{t('login.noAccount')} <Link to="/signup" state={location.state}>{t('login.signUpHere')}</Link></>}>
    <AuthNotice success>{location.state?.emailVerified ? t('verify.loginSuccess') : location.state?.accountCreated && !location.state?.verificationError ? t('signup.loginNext') : null}</AuthNotice>
    <AuthNotice>{location.state?.verificationError && !error ? t('verify.signupSendFailed') : null}</AuthNotice>
    <AuthNotice>{error && t(error)}</AuthNotice>
    <form aria-labelledby="auth-title" className="auth-form" onSubmit={submit} aria-busy={busy}>
      <div className="auth-field"><label htmlFor="email">{t('login.email')}</label>
        <input id="email" name="email" type="email" autoComplete="username" autoCapitalize="none" spellCheck="false" dir="ltr"
          value={email} onChange={e => setEmail(e.target.value)} required disabled={busy} placeholder="name@company.com" />
      </div>
      <PasswordField value={password} onChange={e => setPassword(e.target.value)} disabled={busy} />
      <div className="auth-forgot"><Link to="/forgot-password">{t('login.forgotPassword')}</Link></div>
      <button className="auth-primary" type="submit" disabled={busy}>{t(busy ? 'login.signingIn' : 'login.button')}</button>
    </form>
  </AuthLayout>;
}
